import { render, staticRenderFns } from "./RightPanelRender.vue?vue&type=template&id=1d131482"
import script from "./RightPanelRender.vue?vue&type=script&lang=js"
export * from "./RightPanelRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports